import React from 'react'
import DialogFooter from 'components/modals/dialog-footer'
import Button from 'components/ui/button'
import DiscoModal from 'components/ui/disco-modal'
import Heading from 'components/ui/heading'
import Icon from 'components/ui/icon'
import Text from 'components/ui/text'
import VerticalSpacer from 'components/ui/vertical-spacer'
import styles from './index.module.css'

type Props = {
  onClose: (...args: Array<any>) => any
  onSubmit: (...args: Array<any>) => any
}

const RemoveWatermarkingModal = ({
  onClose,
  onSubmit,
}: Props): React.ReactNode => (
  <DiscoModal onRequestClose={onClose} isOpen handle>
    <div className="modal-width--400">
      <Heading size={600}>
        <Icon className={styles.removeWatermarkingModalIcon} type="warning" />{' '}
        <span>Remove watermarking</span>
      </Heading>

      <Text type="paragraph" display="block">
        Are you sure you want to remove watermarking from this playlist? If you
        remove watermarking, the next time anyone accesses this playlist the
        files won’t be watermarked.
      </Text>
      <VerticalSpacer />

      <DialogFooter
        onClose={onClose}
        primary={
          <Button
            appearance="danger"
            caption="Remove watermarking"
            onClick={onSubmit}
          />
        }
      />
    </div>
  </DiscoModal>
)

export default RemoveWatermarkingModal
